import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { SectionSelectOption } from 'common/components/section-select/section-select.component';
import { Option } from 'common/components/select/select.component';
import { User } from 'common/models';
import { UserEntity } from 'private/app/models/user.model';
import { AuthState } from 'common/store/auth/auth.state';
import { Observable } from 'rxjs';
import { IdmService } from 'private/app/services/idm.service';
import { environment } from 'common/environments/environment';

@Component({
    selector: 'app-profile-landing',
    templateUrl: './profile-landing.component.html',
    styleUrls: ['./profile-landing.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ProfileLandingComponent implements OnInit {
    @Select(AuthState.user) user$: Observable<User>;

    public name: string;

    public selectPage: UntypedFormGroup = new UntypedFormGroup({ page: new UntypedFormControl(null) });

    public options: SectionSelectOption[] = [
        {
            name: this.translateService.instant('PROFILE.PROFILE'),
            value: 'profile',
            action: 'link'
        },
        {
            name: this.translateService.instant('PROFILE.SUBSCRIPTIONS'),
            value: 'manage-subscriptions',
            action: 'link'

        },
        {
            name: this.translateService.instant('PROFILE.ROLES'),
            value: environment.profileRolesURL,
            action: 'new_tab'

        },
        // Should only show if user is a dealer: See: #1008
        {
            name: this.translateService.instant('PROFILE.COMPANY_INFO'),
            value: 'company-info',
            action: 'link'
        },
        {
            name: this.translateService.instant('PROFILE.DELETE_MY_ACCOUNT'),
            value: 'delete-account',
            action: 'link'
        }
    ];

    constructor(
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly translateService: TranslateService,
        private readonly idmService: IdmService

    ) {
        this.selectPage.controls.page.setValue([this.options.find((option: Option) => this.route.snapshot.firstChild?.routeConfig?.path === option.value)]);
    }

    ngOnInit(): void {
        this.user$.subscribe((res: User) => {
            if (res) {
                this.name = `${res.profile.firstName} ${res.profile.lastName}`;
            }
        });

        this.user$.subscribe((user: User) => {
            if (user) {
                this.idmService.getUser(user.profile.login).subscribe((res: UserEntity) => {
                    this.idmService.userInfo$.next(res);
                });
            }
        });

        this.selectPage.controls.page.valueChanges.subscribe((raw: SectionSelectOption | SectionSelectOption[]) => {
            const selected = Array.isArray(raw) ? raw[0] : raw;
            if (!selected?.value) {
                return;
            }
            if (selected.action === 'new_tab') {
                window.open(selected.value, '_blank', 'noopener,noreferrer');
                const currentOption = this.options.find(
                    (option: SectionSelectOption) => this.route.snapshot.firstChild?.routeConfig?.path === option.value
                );
                this.selectPage.controls.page.setValue([currentOption], { emitEvent: false });

                return;
            }
            this.router.navigate([selected.value], { relativeTo: this.route });
        });
    }
}
